<div class="container policy-page" *ngIf="data">
    <div class="policy-page__body">
        <div [innerHTML]="data.documentBody | storyblokRichtext"></div>
    </div>
</div>